import logo from "img/logo_size_invert.png";

const Logo = () => {
  return (
    <a className="logo-ppal" href="/">
      <img className="logo" src={logo} alt="Logo Jet-Shop" />
    </a>
  );
};

export default Logo;
